import { useMemo } from 'react';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import useExchangeRates from '@/shared/data/useExchangeRates';
import normalizeStats from '@/utils/normalizeStats';

const useAggregateTakerMarketStats = (takerMarkets: TakerMarket[]) => {
  // get the exchange rates for market currencies
  const { data: exchangeRates } = useExchangeRates();
  // map the market stats to exchange rates
  const takerMarketStats = useMemo(() => normalizeStats(takerMarkets, exchangeRates), [exchangeRates, takerMarkets]);

  return takerMarketStats;
};

export default useAggregateTakerMarketStats;
